import RefreshIcon from "@mui/icons-material/Refresh";
import { Button } from "@mui/material";

/**
 * Component to display a refresh button that triggers multiple fetch functions.
 *
 * @param {Object} props - Component properties.
 * @param {function} props.fetchAuto4clientLogStreams - Function to fetch Auto4client log streams.
 * @param {function} props.fetchDataCheckerLogStreams - Function to fetch Data Checker log streams.
 * @param {function} props.fetchScraperLogStreams - Function to fetch Scraper log streams.
 * @param {function} props.fetchMongoTaskLogs - Function to fetch Task logs from MongoDB.
 * @param {function} props.fetchErrorList - Function to fetch Error logs.
 */
function RefreshButton({
  fetchAuto4clientLogStreams,
  fetchDataCheckerLogStreams,
  fetchScraperLogStreams,
  fetchMongoTaskLogs,
  fetchErrorList,
}) {
  const handleRefresh = () => {
    [
      fetchAuto4clientLogStreams,
      fetchDataCheckerLogStreams,
      fetchScraperLogStreams,
      fetchMongoTaskLogs,
      fetchErrorList,
    ].forEach((fn) => fn());
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<RefreshIcon />}
      sx={{ px: 2, py: 1, mr: 1, ml: 4 }}
      onClick={handleRefresh}
    >
      Refresh
    </Button>
  );
}

export default RefreshButton;
